export enum NotificationType {
    // СМС
    SMS = 0,
    // Электронная почта
    EMAIL = 1,
    // Пуш уведомление
    PUSH = 2,
    // Локальный хаб
    HUB = 3,
    // Все
    ALL = 4
}